import React from "react";
import {Skeleton} from "@mui/lab";

export const AlertSkeleton = () => (
    <React.Fragment>
        <Skeleton  variant="rect" height={90} style={{margin:'10px 0',borderRadius:12}}/>
    </React.Fragment>
)